import { CellPlugin } from '@react-page/editor';
import moment from "moment-timezone";
import { Col, Row } from 'react-bootstrap';

type Data = {
  title: string
  fontColor: string,
}

const FONT_COLOR = '#000000';
const currentYear = moment().get("year");

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const CopyrightFooterPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <footer className="footer section py-5 d-print-none">
      <Row>
        <Col lg={12}>
          <p style={{color: checkStyleForDefault(data.fontColor, FONT_COLOR)}} className="mb-0 text-center">
            Copyright &copy; {`${currentYear} `}
          </p>
        </Col>
      </Row>
    </footer>
  ),
  id: 'copyrightFooterPlugin',
  title: 'Copyright Footer',
  description: 'A generic copyright footer.',
  version: 1,
  controls:[{
    title: 'Styles',
    controls: {
        type: 'autoform',
        schema: {
            properties: {
                fontColor: {
                    type: 'string',
                    default: FONT_COLOR,
                },
            },
            required: [],
        },
    },
},]
};

export default CopyrightFooterPlugin;